import { IIAMCredentialMeta } from "api/entities/iam-credentials";
import { Entity } from "../../api/entities/id-name";
import { DialogActions } from "./dialog";

const IAM_CREDENTIALS_ENTITY_NAME = 'IAMCredentials';

export const DELETE_CONFIRMATION_DIALOG_NAME = "deleteConfirmation";

export const getIAMCredentialCredentialsEntityName = () => IAM_CREDENTIALS_ENTITY_NAME;

class IAMCredentialsActions<TListItem extends Entity = IIAMCredentialMeta> {
    readonly entity;
    readonly deleteConfirmation;

    constructor() {
        this.deleteConfirmation = new DialogActions<TListItem>(IAM_CREDENTIALS_ENTITY_NAME, DELETE_CONFIRMATION_DIALOG_NAME);
    }
}

export const iamCredentialsActions = new IAMCredentialsActions();
